import { useSelector } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import Overlay from '../../shared/components/Overlay';
import DataCard from '../../shared/components/DataCard';
import TabsCard from './TabsCard';
import PERMISSIONS from '../../shared/permissions';
import usePermissions from '../../shared/hooks/usePermissions';
import { useGetAccountStatisticsQuery } from './apiSlice';
import { accountSelector } from '../../shared/store/shared/accountSlice';
import { useClearAlertMessages } from '../../shared/components/AlertGroup/useAccountAlerts';

export default function People() {
  useClearAlertMessages();
  const { hasAccess, isLoading: isAccessLoading } = usePermissions();
  const { currentAccountId } = useSelector(accountSelector);
  const {
    data: statistics,
    isLoading: statisticsLoading,
    isFetching: statisticsFetching,
  } = useGetAccountStatisticsQuery(currentAccountId, {
    skip: !currentAccountId,
  });

  return (
    <div className="d-block people" data-testid="people-page">
      <Row data-testid="data-cards">
        <Col lg="4" md="4" sm="4" xs="12">
          <DataCard
            title="Total Registered Users"
            total={statistics?.totalRegisteredUsers}
            loading={statisticsLoading || statisticsFetching}
          />
        </Col>
        <Col lg="4" md="4" sm="4" xs="6">
          <div className="d-none d-sm-block">
            <DataCard
              title="Administrators"
              total={statistics?.totalAdministratorsCount}
              loading={statisticsLoading || statisticsFetching}
            />
          </div>
          <div className="d-block d-sm-none">
            <DataCard
              title="Administrators"
              total={statistics?.totalAdministratorsCount}
              loading={statisticsLoading || statisticsFetching}
            />
          </div>
        </Col>
        <Col lg="4" md="4" sm="4" xs="6">
          <div className="d-none d-sm-block">
            <DataCard
              title="Pending Invites"
              total={statistics?.totalPendingInvites}
              loading={statisticsLoading || statisticsFetching}
            />
          </div>
          <div className="d-block d-sm-none">
            <DataCard
              title="Pending Invites"
              total={statistics?.totalPendingInvites}
              loading={statisticsLoading || statisticsFetching}
            />
          </div>
        </Col>
      </Row>
      {!isAccessLoading && (
        <TabsCard
          internalAdmin={hasAccess({
            permissions: [PERMISSIONS.ManageElevatedAdmins],
          })}
        />
      )}
      <Overlay
        variant="PMIOverlay"
        global
        animated
        fade
        iconColor="brand-dark"
        overlayColor="black"
        overlayOpacity={1}
        show={isAccessLoading}
      />
    </div>
  );
}
